// extracted by mini-css-extract-plugin
module.exports = {"subscription":"SectionSubscription_subscription_3xyDs"};